Object.defineProperty(Set.prototype, 'firstValue', {
  value() {
    return this.values().next().value;
  },
});

Object.defineProperty(Set.prototype, 'lastValue', {
  value() {
    let value;
    for (value of this) { }
    return value;
  },
});
